import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import Col from 'components/Col';
import ValidationGroup from 'helpers/validation';
import PropTypes from 'prop-types';
import {inRange} from './helpers';
import {injectIntl, intlShape} from 'react-intl';

class Oval extends React.Component {
  static propTypes = {
    group: PropTypes.instanceOf(ValidationGroup).isRequired,
    intl: intlShape,
  };

  static initialState = {
    length: undefined,
    width: undefined,
  };

  state = Oval.initialState;

  update = ({key, value}) => {
    this.setState({[key]: parseFloat(value)});
  };

  volume = averageDepth => {
    return this.state.length * this.state.width * averageDepth * 5.9;
  };

  reset = () => {
    this.setState(Oval.initialState);
  };

  render() {
    const {formatMessage} = this.props.intl;

    return [
      <Col md={4} key='length-col'>
        <LayoutInput type='number'
                     dataKey='length'
                     autoFocus
                     step='0.01'
                     validate={inRange}
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.length.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.length'})}
                     group={this.props.group}
                     dataChanged={this.update}
                     value={this.state.length}
                     required />
      </Col>,
      <Col md={4} key='width-col'>
        <LayoutInput type='number'
                     dataKey='width'
                     step='0.01'
                     validate={inRange}
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.width.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.width'})}
                     group={this.props.group}
                     dataChanged={this.update}
                     value={this.state.width}
                     required />
      </Col>,
    ];
  }
}

export default injectIntl(Oval, {withRef: true});
